export default () => ({
  isOpen: false,
  activeAccordion: null,

  openMobileNav() {
    this.isOpen = true;
    // Prevent body scroll when menu is open
    document.body.style.overflow = 'hidden';
  },

  closeMobileNav() {
    this.isOpen = false;
    this.activeAccordion = null;
    // Restore body scroll
    document.body.style.overflow = '';
  },

  toggleAccordion(nodeId) {
    this.activeAccordion = this.activeAccordion === nodeId ? null : nodeId;
  },

  isAccordionOpen(nodeId) {
    return this.activeAccordion === nodeId;
  }
});